import { ExclusivePlaylists, DownloadPageLayout } from '@bpm-web-app/components';

export default function ExclusivePlaylistsPage({ title }: { title: string }) {
    return (
        <DownloadPageLayout title={title}>
            <ExclusivePlaylists />
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Exclusive Playlists',
        },
    };
}
